/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLogicNand = createReactComponent("logic-nand", "IconLogicNand", [
  ["path", { d: "M22 12h-3", key: "svg-0" }],
  ["path", { d: "M2 9h3", key: "svg-1" }],
  ["path", { d: "M2 15h3", key: "svg-2" }],
  ["path", { d: "M7 5c6 0 8 3.5 8 7s-2 7 -8 7h-2v-14h2z", key: "svg-3" }],
  ["path", { d: "M17 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", key: "svg-4" }]
]);

export { IconLogicNand as default };
//# sourceMappingURL=IconLogicNand.js.map
